import { Link, LinkProps } from 'react-router-dom'
import { LuChevronLeft } from 'react-icons/lu'
import Typography from '@mui/material/Typography'
import ListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton'

export default function BackButton(props: LinkProps & ListItemButtonProps) {
  return (
    <ListItemButton component={Link} {...props} sx={{ marginX: -2, ...props.sx }}>
      <LuChevronLeft />
      <Typography variant="subtitle2" sx={{ ml: 2 }}>
        {props.children}
      </Typography>
    </ListItemButton>
  )
}
